function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-1.118 .21)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 570.44,
  cy: 333.584,
  fill: "#23C386",
  rx: 4.592,
  ry: 4.59,
  transform: "rotate(40 570.44 333.584)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 288.16,
  cy: 438.8,
  fill: "#23C386",
  rx: 2.087,
  ry: 2.086,
  transform: "rotate(40 288.16 438.8)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 620.794,
  cy: 211.88,
  fill: "#23C386",
  rx: 1.67,
  ry: 1.669,
  transform: "rotate(40 620.794 211.88)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 286.073,
  cy: 556.884,
  fill: "#23C386",
  rx: 2.087,
  ry: 2.086,
  transform: "rotate(40 286.073 556.884)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.855,
  cy: 505.636,
  fill: "#23C386",
  rx: 2.922,
  ry: 2.921,
  transform: "rotate(40 180.855 505.636)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 551.843,
  cy: 249.892,
  fill: "#23C386",
  transform: "rotate(40 551.843 249.892)",
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 396.247,
  cy: 745.744,
  fill: "#23C386",
  rx: 2.505,
  ry: 2.504,
  transform: "rotate(40 396.247 745.744)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 491.616,
  cy: 400.897,
  fill: "#23C386",
  rx: 10.018,
  ry: 10.014,
  transform: "rotate(40 491.616 400.897)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 652.751,
  cy: 245.231,
  fill: "#23C386",
  transform: "rotate(40 652.75 245.231)",
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 296.276,
  cy: 207.028,
  fill: "#23C386",
  transform: "rotate(40 296.276 207.028)",
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 286.661,
  cy: 556.832,
  fill: "#23C386",
  rx: 3.339,
  ry: 3.338,
  transform: "rotate(40 286.66 556.832)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 410.455,
  cy: 630.75,
  fill: "#23C386",
  rx: 7.096,
  ry: 7.094,
  transform: "rotate(40 410.455 630.75)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 563.109,
  cy: 520.26,
  fill: "#23C386",
  transform: "rotate(40 563.11 520.26)",
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 542.329,
  cy: 475.119,
  fill: "#23C386",
  rx: 6.262,
  ry: 6.259,
  transform: "rotate(40 542.329 475.12)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 190.114,
  cy: 334.196,
  fill: "#23C386",
  rx: 4.174,
  ry: 4.173,
  transform: "rotate(40 190.114 334.196)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 605.928,
  cy: 549.108,
  fill: "#23C386",
  rx: 5.844,
  ry: 5.842,
  transform: "rotate(40 605.928 549.108)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 625.361,
  cy: 304.499,
  fill: "#23C386",
  rx: 10.436,
  ry: 10.432,
  transform: "rotate(40 625.36 304.5)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 477.051,
  cy: 694.256,
  fill: "#23C386",
  rx: 2.922,
  ry: 2.921,
  transform: "rotate(40 477.05 694.256)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 120.181,
  cy: 8.818,
  fill: "#1F78B4",
  rx: 8.77,
  ry: 8.765
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 462.645,
  cy: 168.264,
  fill: "#1F78B4",
  rx: 10.441,
  ry: 10.435
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 68.812,
  cy: 465.034,
  fill: "#1F78B4",
  rx: 8.353,
  ry: 8.348
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 313.966,
  cy: 447.92,
  fill: "#1F78B4",
  rx: 10.441,
  ry: 10.435
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 279.719,
  cy: 231.708,
  fill: "#1F78B4",
  rx: 2.923,
  ry: 2.922
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 422.552,
  cy: 505.521,
  fill: "#1F78B4",
  rx: 9.606,
  ry: 9.6
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 205.797,
  cy: 379.885,
  fill: "#1F78B4",
  rx: 4.176,
  ry: 4.174
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 508.167,
  cy: 374.041,
  fill: "#1F78B4",
  rx: 5.847,
  ry: 5.844
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 514.014,
  cy: 277.205,
  fill: "#1F78B4",
  rx: 1.671,
  ry: 1.67
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.764,
  cy: 161.471,
  fill: "#1F78B4",
  rx: 8.353,
  ry: 8.348
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 434.245,
  cy: 225.865,
  fill: "#1F78B4",
  rx: 2.088,
  ry: 2.087
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 605.477,
  cy: 374.458,
  fill: "#1F78B4",
  rx: 6.265,
  ry: 6.261
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 588.354,
  cy: 379.885,
  fill: "#1F78B4",
  rx: 1.671,
  ry: 1.67
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 388.723,
  cy: 339.814,
  fill: "#1F78B4",
  rx: 4.176,
  ry: 4.174
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 261.133,
  cy: 94.591,
  fill: "#00C880",
  rx: 9.606,
  ry: 9.6
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 623.018,
  cy: 482.147,
  fill: "#1F78B4",
  rx: 7.1,
  ry: 7.096
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 143.151,
  cy: 242.978,
  fill: "#1F78B4",
  rx: 3.341,
  ry: 3.339
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 365.753,
  cy: 311.014,
  fill: "#1F78B4",
  rx: 1.253,
  ry: 1.252
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 447.886,
  cy: 503.769,
  fill: "#7A3390",
  rx: 8.766,
  ry: 8.763,
  transform: "rotate(10 447.886 503.769)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 157.83,
  cy: 603.04,
  fill: "#7A3390",
  rx: 9.184,
  ry: 9.18,
  transform: "rotate(10 157.83 603.04)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 178.022,
  cy: 490.929,
  fill: "#7A3390",
  rx: 7.096,
  ry: 7.094,
  transform: "rotate(10 178.022 490.929)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74.622,
  cy: 252.793,
  fill: "#7A3390",
  transform: "rotate(10 74.622 252.793)",
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 321.39,
  cy: 363.629,
  fill: "#7A3390",
  rx: 10.018,
  ry: 10.014,
  transform: "rotate(10 321.39 363.629)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 335.855,
  cy: 153.523,
  fill: "#7A3390",
  rx: 2.087,
  ry: 2.086,
  transform: "rotate(10 335.855 153.523)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 76.493,
  cy: 177.279,
  fill: "#7A3390",
  rx: 4.592,
  ry: 4.59,
  transform: "rotate(10 76.493 177.279)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.679,
  cy: 362.345,
  fill: "#7A3390",
  rx: 6.679,
  ry: 6.676,
  transform: "rotate(10 8.679 362.345)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 567.42,
  cy: 188.846,
  fill: "#7A3390",
  rx: 2.505,
  ry: 2.504,
  transform: "rotate(10 567.42 188.846)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70.508,
  cy: 507.189,
  r: 1,
  fill: "#7A3390",
  transform: "rotate(10 70.508 507.19)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 254.315,
  cy: 382.777,
  fill: "#7A3390",
  rx: 8.349,
  ry: 8.345,
  transform: "rotate(10 254.315 382.777)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 573.148,
  cy: 288.58,
  fill: "#7A3390",
  rx: 7.931,
  ry: 7.928,
  transform: "rotate(10 573.148 288.58)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 107.676,
  cy: 594.197,
  fill: "#7A3390",
  rx: 5.844,
  ry: 5.842,
  transform: "rotate(10 107.676 594.197)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 351.25,
  cy: 232.082,
  fill: "#7A3390",
  rx: 7.514,
  ry: 7.511,
  transform: "rotate(10 351.25 232.082)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 285.521,
  cy: 208.204,
  fill: "#7A3390",
  rx: 9.601,
  ry: 9.597,
  transform: "rotate(10 285.52 208.204)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 94.565,
  cy: 336.813,
  fill: "#7A3390",
  rx: 6.679,
  ry: 6.676,
  transform: "rotate(10 94.565 336.813)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 123.203,
  cy: 371.522,
  fill: "#7A3390",
  rx: 9.184,
  ry: 9.18,
  transform: "rotate(10 123.203 371.522)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 228.576,
  cy: 331.631,
  fill: "#7A3390",
  rx: 5.844,
  ry: 5.842,
  transform: "rotate(10 228.576 331.63)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 371.323,
  cy: 478.829,
  fill: "#7A3390",
  transform: "rotate(10 371.323 478.829)",
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 77.079,
  cy: 438.386,
  fill: "#7A3390",
  rx: 10.436,
  ry: 10.432,
  transform: "rotate(10 77.079 438.386)"
}));

function SvgDemographics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 653 749"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NTMgNzQ5Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjExOCAuMjEpIj4KICAgIDxlbGxpcHNlIGN4PSI1NzAuNDQiIGN5PSIzMzMuNTg0IiBmaWxsPSIjMjNDMzg2IiByeD0iNC41OTIiIHJ5PSI0LjU5IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA1NzAuNDQgMzMzLjU4NCkiLz4KICAgIDxlbGxpcHNlIGN4PSIyODguMTYiIGN5PSI0MzguOCIgZmlsbD0iIzIzQzM4NiIgcng9IjIuMDg3IiByeT0iMi4wODYiIHRyYW5zZm9ybT0icm90YXRlKDQwIDI4OC4xNiA0MzguOCkiLz4KICAgIDxlbGxpcHNlIGN4PSI2MjAuNzk0IiBjeT0iMjExLjg4IiBmaWxsPSIjMjNDMzg2IiByeD0iMS42NyIgcnk9IjEuNjY5IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA2MjAuNzk0IDIxMS44OCkiLz4KICAgIDxlbGxpcHNlIGN4PSIyODYuMDczIiBjeT0iNTU2Ljg4NCIgZmlsbD0iIzIzQzM4NiIgcng9IjIuMDg3IiByeT0iMi4wODYiIHRyYW5zZm9ybT0icm90YXRlKDQwIDI4Ni4wNzMgNTU2Ljg4NCkiLz4KICAgIDxlbGxpcHNlIGN4PSIxODAuODU1IiBjeT0iNTA1LjYzNiIgZmlsbD0iIzIzQzM4NiIgcng9IjIuOTIyIiByeT0iMi45MjEiIHRyYW5zZm9ybT0icm90YXRlKDQwIDE4MC44NTUgNTA1LjYzNikiLz4KICAgIDxlbGxpcHNlIGN4PSI1NTEuODQzIiBjeT0iMjQ5Ljg5MiIgZmlsbD0iIzIzQzM4NiIgcng9IjEiIHJ5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA1NTEuODQzIDI0OS44OTIpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMzk2LjI0NyIgY3k9Ijc0NS43NDQiIGZpbGw9IiMyM0MzODYiIHJ4PSIyLjUwNSIgcnk9IjIuNTA0IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAzOTYuMjQ3IDc0NS43NDQpIi8+CiAgICA8ZWxsaXBzZSBjeD0iNDkxLjYxNiIgY3k9IjQwMC44OTciIGZpbGw9IiMyM0MzODYiIHJ4PSIxMC4wMTgiIHJ5PSIxMC4wMTQiIHRyYW5zZm9ybT0icm90YXRlKDQwIDQ5MS42MTYgNDAwLjg5NykiLz4KICAgIDxlbGxpcHNlIGN4PSI2NTIuNzUxIiBjeT0iMjQ1LjIzMSIgZmlsbD0iIzIzQzM4NiIgcng9IjEiIHJ5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA2NTIuNzUgMjQ1LjIzMSkiLz4KICAgIDxlbGxpcHNlIGN4PSIyOTYuMjc2IiBjeT0iMjA3LjAyOCIgZmlsbD0iIzIzQzM4NiIgcng9IjEiIHJ5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAyOTYuMjc2IDIwNy4wMjgpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMjg2LjY2MSIgY3k9IjU1Ni44MzIiIGZpbGw9IiMyM0MzODYiIHJ4PSIzLjMzOSIgcnk9IjMuMzM4IiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAyODYuNjYgNTU2LjgzMikiLz4KICAgIDxlbGxpcHNlIGN4PSI0MTAuNDU1IiBjeT0iNjMwLjc1IiBmaWxsPSIjMjNDMzg2IiByeD0iNy4wOTYiIHJ5PSI3LjA5NCIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgNDEwLjQ1NSA2MzAuNzUpIi8+CiAgICA8ZWxsaXBzZSBjeD0iNTYzLjEwOSIgY3k9IjUyMC4yNiIgZmlsbD0iIzIzQzM4NiIgcng9IjEiIHJ5PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA1NjMuMTEgNTIwLjI2KSIvPgogICAgPGVsbGlwc2UgY3g9IjU0Mi4zMjkiIGN5PSI0NzUuMTE5IiBmaWxsPSIjMjNDMzg2IiByeD0iNi4yNjIiIHJ5PSI2LjI1OSIgdHJhbnNmb3JtPSJyb3RhdGUoNDAgNTQyLjMyOSA0NzUuMTIpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMTkwLjExNCIgY3k9IjMzNC4xOTYiIGZpbGw9IiMyM0MzODYiIHJ4PSI0LjE3NCIgcnk9IjQuMTczIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCAxOTAuMTE0IDMzNC4xOTYpIi8+CiAgICA8ZWxsaXBzZSBjeD0iNjA1LjkyOCIgY3k9IjU0OS4xMDgiIGZpbGw9IiMyM0MzODYiIHJ4PSI1Ljg0NCIgcnk9IjUuODQyIiB0cmFuc2Zvcm09InJvdGF0ZSg0MCA2MDUuOTI4IDU0OS4xMDgpIi8+CiAgICA8ZWxsaXBzZSBjeD0iNjI1LjM2MSIgY3k9IjMwNC40OTkiIGZpbGw9IiMyM0MzODYiIHJ4PSIxMC40MzYiIHJ5PSIxMC40MzIiIHRyYW5zZm9ybT0icm90YXRlKDQwIDYyNS4zNiAzMDQuNSkiLz4KICAgIDxlbGxpcHNlIGN4PSI0NzcuMDUxIiBjeT0iNjk0LjI1NiIgZmlsbD0iIzIzQzM4NiIgcng9IjIuOTIyIiByeT0iMi45MjEiIHRyYW5zZm9ybT0icm90YXRlKDQwIDQ3Ny4wNSA2OTQuMjU2KSIvPgogICAgPGVsbGlwc2UgY3g9IjEyMC4xODEiIGN5PSI4LjgxOCIgZmlsbD0iIzFGNzhCNCIgcng9IjguNzciIHJ5PSI4Ljc2NSIvPgogICAgPGVsbGlwc2UgY3g9IjQ2Mi42NDUiIGN5PSIxNjguMjY0IiBmaWxsPSIjMUY3OEI0IiByeD0iMTAuNDQxIiByeT0iMTAuNDM1Ii8+CiAgICA8ZWxsaXBzZSBjeD0iNjguODEyIiBjeT0iNDY1LjAzNCIgZmlsbD0iIzFGNzhCNCIgcng9IjguMzUzIiByeT0iOC4zNDgiLz4KICAgIDxlbGxpcHNlIGN4PSIzMTMuOTY2IiBjeT0iNDQ3LjkyIiBmaWxsPSIjMUY3OEI0IiByeD0iMTAuNDQxIiByeT0iMTAuNDM1Ii8+CiAgICA8ZWxsaXBzZSBjeD0iMjc5LjcxOSIgY3k9IjIzMS43MDgiIGZpbGw9IiMxRjc4QjQiIHJ4PSIyLjkyMyIgcnk9IjIuOTIyIi8+CiAgICA8ZWxsaXBzZSBjeD0iNDIyLjU1MiIgY3k9IjUwNS41MjEiIGZpbGw9IiMxRjc4QjQiIHJ4PSI5LjYwNiIgcnk9IjkuNiIvPgogICAgPGVsbGlwc2UgY3g9IjIwNS43OTciIGN5PSIzNzkuODg1IiBmaWxsPSIjMUY3OEI0IiByeD0iNC4xNzYiIHJ5PSI0LjE3NCIvPgogICAgPGVsbGlwc2UgY3g9IjUwOC4xNjciIGN5PSIzNzQuMDQxIiBmaWxsPSIjMUY3OEI0IiByeD0iNS44NDciIHJ5PSI1Ljg0NCIvPgogICAgPGVsbGlwc2UgY3g9IjUxNC4wMTQiIGN5PSIyNzcuMjA1IiBmaWxsPSIjMUY3OEI0IiByeD0iMS42NzEiIHJ5PSIxLjY3Ii8+CiAgICA8ZWxsaXBzZSBjeD0iMTkyLjc2NCIgY3k9IjE2MS40NzEiIGZpbGw9IiMxRjc4QjQiIHJ4PSI4LjM1MyIgcnk9IjguMzQ4Ii8+CiAgICA8ZWxsaXBzZSBjeD0iNDM0LjI0NSIgY3k9IjIyNS44NjUiIGZpbGw9IiMxRjc4QjQiIHJ4PSIyLjA4OCIgcnk9IjIuMDg3Ii8+CiAgICA8ZWxsaXBzZSBjeD0iNjA1LjQ3NyIgY3k9IjM3NC40NTgiIGZpbGw9IiMxRjc4QjQiIHJ4PSI2LjI2NSIgcnk9IjYuMjYxIi8+CiAgICA8ZWxsaXBzZSBjeD0iNTg4LjM1NCIgY3k9IjM3OS44ODUiIGZpbGw9IiMxRjc4QjQiIHJ4PSIxLjY3MSIgcnk9IjEuNjciLz4KICAgIDxlbGxpcHNlIGN4PSIzODguNzIzIiBjeT0iMzM5LjgxNCIgZmlsbD0iIzFGNzhCNCIgcng9IjQuMTc2IiByeT0iNC4xNzQiLz4KICAgIDxlbGxpcHNlIGN4PSIyNjEuMTMzIiBjeT0iOTQuNTkxIiBmaWxsPSIjMDBDODgwIiByeD0iOS42MDYiIHJ5PSI5LjYiLz4KICAgIDxlbGxpcHNlIGN4PSI2MjMuMDE4IiBjeT0iNDgyLjE0NyIgZmlsbD0iIzFGNzhCNCIgcng9IjcuMSIgcnk9IjcuMDk2Ii8+CiAgICA8ZWxsaXBzZSBjeD0iMTQzLjE1MSIgY3k9IjI0Mi45NzgiIGZpbGw9IiMxRjc4QjQiIHJ4PSIzLjM0MSIgcnk9IjMuMzM5Ii8+CiAgICA8ZWxsaXBzZSBjeD0iMzY1Ljc1MyIgY3k9IjMxMS4wMTQiIGZpbGw9IiMxRjc4QjQiIHJ4PSIxLjI1MyIgcnk9IjEuMjUyIi8+CiAgICA8ZWxsaXBzZSBjeD0iNDQ3Ljg4NiIgY3k9IjUwMy43NjkiIGZpbGw9IiM3QTMzOTAiIHJ4PSI4Ljc2NiIgcnk9IjguNzYzIiB0cmFuc2Zvcm09InJvdGF0ZSgxMCA0NDcuODg2IDUwMy43NjkpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMTU3LjgzIiBjeT0iNjAzLjA0IiBmaWxsPSIjN0EzMzkwIiByeD0iOS4xODQiIHJ5PSI5LjE4IiB0cmFuc2Zvcm09InJvdGF0ZSgxMCAxNTcuODMgNjAzLjA0KSIvPgogICAgPGVsbGlwc2UgY3g9IjE3OC4wMjIiIGN5PSI0OTAuOTI5IiBmaWxsPSIjN0EzMzkwIiByeD0iNy4wOTYiIHJ5PSI3LjA5NCIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgMTc4LjAyMiA0OTAuOTI5KSIvPgogICAgPGVsbGlwc2UgY3g9Ijc0LjYyMiIgY3k9IjI1Mi43OTMiIGZpbGw9IiM3QTMzOTAiIHJ4PSIxIiByeT0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgNzQuNjIyIDI1Mi43OTMpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMzIxLjM5IiBjeT0iMzYzLjYyOSIgZmlsbD0iIzdBMzM5MCIgcng9IjEwLjAxOCIgcnk9IjEwLjAxNCIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgMzIxLjM5IDM2My42MjkpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMzM1Ljg1NSIgY3k9IjE1My41MjMiIGZpbGw9IiM3QTMzOTAiIHJ4PSIyLjA4NyIgcnk9IjIuMDg2IiB0cmFuc2Zvcm09InJvdGF0ZSgxMCAzMzUuODU1IDE1My41MjMpIi8+CiAgICA8ZWxsaXBzZSBjeD0iNzYuNDkzIiBjeT0iMTc3LjI3OSIgZmlsbD0iIzdBMzM5MCIgcng9IjQuNTkyIiByeT0iNC41OSIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgNzYuNDkzIDE3Ny4yNzkpIi8+CiAgICA8ZWxsaXBzZSBjeD0iOC42NzkiIGN5PSIzNjIuMzQ1IiBmaWxsPSIjN0EzMzkwIiByeD0iNi42NzkiIHJ5PSI2LjY3NiIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgOC42NzkgMzYyLjM0NSkiLz4KICAgIDxlbGxpcHNlIGN4PSI1NjcuNDIiIGN5PSIxODguODQ2IiBmaWxsPSIjN0EzMzkwIiByeD0iMi41MDUiIHJ5PSIyLjUwNCIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgNTY3LjQyIDE4OC44NDYpIi8+CiAgICA8Y2lyY2xlIGN4PSI3MC41MDgiIGN5PSI1MDcuMTg5IiByPSIxIiBmaWxsPSIjN0EzMzkwIiB0cmFuc2Zvcm09InJvdGF0ZSgxMCA3MC41MDggNTA3LjE5KSIvPgogICAgPGVsbGlwc2UgY3g9IjI1NC4zMTUiIGN5PSIzODIuNzc3IiBmaWxsPSIjN0EzMzkwIiByeD0iOC4zNDkiIHJ5PSI4LjM0NSIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgMjU0LjMxNSAzODIuNzc3KSIvPgogICAgPGVsbGlwc2UgY3g9IjU3My4xNDgiIGN5PSIyODguNTgiIGZpbGw9IiM3QTMzOTAiIHJ4PSI3LjkzMSIgcnk9IjcuOTI4IiB0cmFuc2Zvcm09InJvdGF0ZSgxMCA1NzMuMTQ4IDI4OC41OCkiLz4KICAgIDxlbGxpcHNlIGN4PSIxMDcuNjc2IiBjeT0iNTk0LjE5NyIgZmlsbD0iIzdBMzM5MCIgcng9IjUuODQ0IiByeT0iNS44NDIiIHRyYW5zZm9ybT0icm90YXRlKDEwIDEwNy42NzYgNTk0LjE5NykiLz4KICAgIDxlbGxpcHNlIGN4PSIzNTEuMjUiIGN5PSIyMzIuMDgyIiBmaWxsPSIjN0EzMzkwIiByeD0iNy41MTQiIHJ5PSI3LjUxMSIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgMzUxLjI1IDIzMi4wODIpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMjg1LjUyMSIgY3k9IjIwOC4yMDQiIGZpbGw9IiM3QTMzOTAiIHJ4PSI5LjYwMSIgcnk9IjkuNTk3IiB0cmFuc2Zvcm09InJvdGF0ZSgxMCAyODUuNTIgMjA4LjIwNCkiLz4KICAgIDxlbGxpcHNlIGN4PSI5NC41NjUiIGN5PSIzMzYuODEzIiBmaWxsPSIjN0EzMzkwIiByeD0iNi42NzkiIHJ5PSI2LjY3NiIgdHJhbnNmb3JtPSJyb3RhdGUoMTAgOTQuNTY1IDMzNi44MTMpIi8+CiAgICA8ZWxsaXBzZSBjeD0iMTIzLjIwMyIgY3k9IjM3MS41MjIiIGZpbGw9IiM3QTMzOTAiIHJ4PSI5LjE4NCIgcnk9IjkuMTgiIHRyYW5zZm9ybT0icm90YXRlKDEwIDEyMy4yMDMgMzcxLjUyMikiLz4KICAgIDxlbGxpcHNlIGN4PSIyMjguNTc2IiBjeT0iMzMxLjYzMSIgZmlsbD0iIzdBMzM5MCIgcng9IjUuODQ0IiByeT0iNS44NDIiIHRyYW5zZm9ybT0icm90YXRlKDEwIDIyOC41NzYgMzMxLjYzKSIvPgogICAgPGVsbGlwc2UgY3g9IjM3MS4zMjMiIGN5PSI0NzguODI5IiBmaWxsPSIjN0EzMzkwIiByeD0iMSIgcnk9IjEiIHRyYW5zZm9ybT0icm90YXRlKDEwIDM3MS4zMjMgNDc4LjgyOSkiLz4KICAgIDxlbGxpcHNlIGN4PSI3Ny4wNzkiIGN5PSI0MzguMzg2IiBmaWxsPSIjN0EzMzkwIiByeD0iMTAuNDM2IiByeT0iMTAuNDMyIiB0cmFuc2Zvcm09InJvdGF0ZSgxMCA3Ny4wNzkgNDM4LjM4NikiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgDemographics as ReactComponent };